import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { ConfirmDailogueComponent } from 'src/app/shared/components/dailogue/confirm-dailogue.component';
import { Api } from 'src/app/shared/constants/api';
import { APP_ROUTES } from 'src/app/shared/constants/approutes';
import { Message } from 'src/app/shared/constants/message';
import { PermissionKey } from 'src/app/shared/constants/permissionCode';
import { IPermissionWithShow } from 'src/app/shared/interface';
import { DataService } from 'src/app/shared/services/data.service';
import { PermissionService } from 'src/app/shared/services/permissions.service';
import { UtilityService } from 'src/app/shared/services/utility.service';
import * as _ from 'underscore';


@Component({
    selector: 'app-equipment-form',
    templateUrl: './equipment-form.component.html',
    styleUrls: ['./equipment-form.component.less'],
    standalone: false
})

export class EquipmentFormComponent implements OnInit
{
  equipmentForm: FormGroup;
  equipmentTypes:any;
  editPermission:boolean=false;
  addPermission:boolean=false;
  
constructor(private formBuilder: FormBuilder,
  @Inject(MAT_DIALOG_DATA) public data: any,
  private dailogRef : MatDialogRef<EquipmentFormComponent>,
  private service:DataService,
  private dailog:MatDialog,
  private logger:NGXLogger,
  private router:Router,
  private permissionService:PermissionService,
  private utilityService: UtilityService)
    {  this.dailogRef.disableClose=true; }

    isEditedData:boolean=false;
    yesNoList=this.utilityService.getYesNoList();

ngOnInit(): void {
  this.checkAllPermissions();
  this.initializeEquipmentForm();
  this.getTypes();
  this.patchValue();
}

private initializeEquipmentForm(){
  this.equipmentForm = this.formBuilder.group({
    id:[],
    name:[null,[Validators.required]],
    code:[null,[Validators.required, Validators.minLength(2), Validators.maxLength(2)]],
    type:[null,[Validators.required]]
    
  });
}

private patchValue() {
  if (this.data?.id)
    this.equipmentForm.patchValue(this.data);
}


/**
   * onSave
   */

Save() {  
  this.equipmentForm.markAllAsTouched();
  if(this.equipmentForm.valid)
  {
    this.isEditedData=true;
    if(this.id.value){
    this.openDailog(Message.SAVE_OPEN_DAILOG_IN_EDIT);
    }
  else {
    this.openDailog(Message.SAVE_OPEN_DAILOG);
    }  
  }
}

saveEquipmentModule(){
  this.equipmentForm.markAllAsTouched();
    let method=(this.id.value) ? 'put' : 'post';
    let message=(this.id.value) ? 'updated' : 'saved';
      if(this.equipmentForm.valid){
      this.name.patchValue(this.name.value.trim().replace(/ +/g, ' '));
      this.service[method](Api.EQUIPMENT, this.equipmentForm.value).subscribe(res => {
      this.utilityService.notifier('Equipment Details '+message+' successfully', 'success');
      this.router.navigate([APP_ROUTES.EQUIPMENT_LIST]);
      this.dailogRef.close();
      });
    }
  }

getTypes(){
  this.service.get(Api.EQUIPMENT_TYPES).subscribe(res => {
      if(res){
        this.equipmentTypes=res;
      }
  })
}
  
    /**
     * cancel
    */
  Cancel() {
  if(this.equipmentForm.dirty){
    this.openDailog(Message.CANCEL_OPEN_DAILOG_IN_EDIT);
  }
  else{
    this.router.navigate([APP_ROUTES.EQUIPMENT_LIST]);
    this.dailogRef.close();
  }
}

private openDailog(message?:string){
  const dailogRef=this.dailog.open(ConfirmDailogueComponent,{
      data:message,
      maxWidth:"300px",
      maxHeight:"150px"
    });

  dailogRef.afterClosed().subscribe(dailogResult => {
      if(dailogResult===false){
        return;
      }
      else {
        if(!this.isEditedData) {
          this.router.navigate([APP_ROUTES.EQUIPMENT_LIST]);
          this.dailogRef.close();
        }
        else{
            this.saveEquipmentModule();
        }
      }
  })
}

public checkAllPermissions(){
  let permissionCodes=[PermissionKey.EQUIPMENT_MODULE_ADD_PERMISSION,PermissionKey.EQUIPMENT_MODULE_EDIT_PERMISSION];
  let permissionsWithShowValue:IPermissionWithShow[]=this.permissionService.checkPermissions(permissionCodes,PermissionKey.EQUIPMENT_MODULE);
  this.editPermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.EQUIPMENT_MODULE_EDIT_PERMISSION})?.show?true:false;
  this.addPermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.EQUIPMENT_MODULE_ADD_PERMISSION})?.show?true:false;
}

  get id(){return this.equipmentForm.get('id')};
  get name(){return this.equipmentForm.get('name')};
  get code(){ return this.equipmentForm.get('code')};
  get type(){ return this.equipmentForm.get('type')};

}
